









import { Vue, Component } from 'vue-property-decorator';
import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
@Component({ components: { DxLoadIndicator } })
export default class Loading extends Vue {

}
